// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"64":"0338c42c","67":"bd6b8a7d","73":"da32023b","314":"2ba79464","320":"a58948f5","530":"a58948f5","637":"a58948f5","663":"a58948f5","733":"c8972376","795":"a58948f5","949":"702ad4e6"}[chunkId] + ".chunk.css";
};